module.exports = __webpack_public_path__ + "assets/img/working-lithuania.b9559c11.jpg";